var map = {
	"./Additive_001.png": 9723,
	"./Additive_002.png": 5904,
	"./Additive_003.png": 2153,
	"./Additive_004.png": 9734,
	"./Additive_005.png": 1279,
	"./Additive_006.png": 7431,
	"./Additive_007.png": 941,
	"./Additive_008.png": 170,
	"./Additive_009.png": 2083,
	"./Additive_010.png": 7101,
	"./Additive_011.png": 3204,
	"./Additive_012.png": 63,
	"./Additive_013.png": 3126,
	"./Additive_014.png": 3209,
	"./Additive_015.png": 6355,
	"./Additive_016.png": 7067,
	"./Additive_017.png": 2242,
	"./Additive_018.png": 3093,
	"./Additive_019.png": 7180,
	"./Additive_020.png": 760,
	"./Additive_021.png": 9153,
	"./Additive_022.png": 2906,
	"./Additive_023.png": 9091,
	"./Additive_024.png": 9692,
	"./Additive_025.png": 1317,
	"./Additive_026.png": 4590,
	"./Additive_027.png": 375,
	"./Animal_016.png": 4743,
	"./Artisanry_001.png": 4218,
	"./Artisanry_019.png": 7049,
	"./Artisanry_Catalyst_003.png": 5256,
	"./Artisanry_Catalyst_005.png": 8670,
	"./Empty_002.png": 5955,
	"./Empty_003.png": 746,
	"./Empty_004.png": 5413,
	"./Feather_001.png": 1666,
	"./Feather_001_1.png": 662,
	"./Feather_001_2.png": 1341,
	"./Feather_002.png": 5673,
	"./Feather_003.png": 3568,
	"./Feather_004.png": 5791,
	"./Feather_005.png": 694,
	"./Feather_006.png": 4461,
	"./Feather_007.png": 3332,
	"./Feather_008.png": 8627,
	"./Feather_009.png": 7866,
	"./Feather_010.png": 8320,
	"./Feather_011.png": 2793,
	"./Feather_012.png": 1826,
	"./Feather_013.png": 6651,
	"./Feather_014.png": 2788,
	"./Feather_015.png": 6685,
	"./Feather_Catalyst_001.png": 4418,
	"./Feather_Catalyst_002.png": 5385,
	"./Feather_Catalyst_003.png": 7264,
	"./Feather_Catalyst_004.png": 8591,
	"./Feather_Catalyst_005.png": 5302,
	"./Feather_Catalyst_006.png": 9277,
	"./Feather_Catalyst_007.png": 5380,
	"./Flower_001.png": 2954,
	"./Flower_002.png": 1937,
	"./Flower_003.png": 3672,
	"./Flower_004.png": 8839,
	"./Fluid_001.png": 9079,
	"./Fluid_002.png": 2044,
	"./Fluid_005.png": 1443,
	"./Fluid_006.png": 9464,
	"./Fluid_007.png": 7857,
	"./Fluid_008.png": 2726,
	"./Fluid_009.png": 6527,
	"./Fluid_010.png": 7705,
	"./Fluid_011.png": 1456,
	"./Fluid_012.png": 2747,
	"./Fluid_013.png": 1618,
	"./Fluid_014.png": 9517,
	"./Fluid_015.png": 2836,
	"./Fluid_016.png": 7327,
	"./Fluid_017.png": 8310,
	"./Fungus_001.png": 5477,
	"./Fungus_001_1.png": 4909,
	"./Fungus_002.png": 1470,
	"./Fungus_003.png": 695,
	"./Fungus_004.png": 8056,
	"./Fungus_005.png": 9185,
	"./Fungus_006.png": 8602,
	"./Fungus_007.png": 3811,
	"./Fungus_008.png": 8516,
	"./Fungus_009.png": 5197,
	"./Fungus_010.png": 4087,
	"./Fungus_011.png": 2750,
	"./Fungus_012.png": 882,
	"./Fungus_013.png": 5612,
	"./Fungus_014.png": 5779,
	"./Insect_001.png": 4739,
	"./Insect_002.png": 248,
	"./Insect_003.png": 2961,
	"./Insect_004.png": 9870,
	"./Insect_005.png": 9863,
	"./Insect_006.png": 4780,
	"./Insect_007.png": 8645,
	"./Insect_008.png": 7778,
	"./Insect_009.png": 5083,
	"./Insect_010.png": 9429,
	"./Insect_011.png": 7804,
	"./Insect_012.png": 8487,
	"./Insect_013.png": 2702,
	"./Insect_014.png": 7265,
	"./Insect_015.png": 8872,
	"./Insect_016.png": 7203,
	"./Mineral_001.png": 8833,
	"./Mineral_002.png": 4170,
	"./Mineral_003.png": 5747,
	"./Mineral_004.png": 5580,
	"./Mineral_005.png": 850,
	"./Mineral_006.png": 2718,
	"./Mineral_007.png": 4055,
	"./Mineral_008.png": 6784,
	"./Mineral_009.png": 1609,
	"./Mineral_010.png": 4419,
	"./Mineral_011.png": 9210,
	"./Mineral_012.png": 8193,
	"./Mineral_013.png": 3576,
	"./Mineral_014.png": 5095,
	"./Mineral_015.png": 2078,
	"./Mineral_016.png": 3877,
	"./None.png": 4509,
	"./Plant_001.png": 3524,
	"./Plant_002.png": 7087,
	"./Plant_003.png": 8998,
	"./Plant_004.png": 3257,
	"./Plant_005.png": 8432,
	"./Plant_010.png": 8914,
	"./Plant_011.png": 43,
	"./Plant_012.png": 8752,
	"./Plant_013.png": 5001,
	"./Plant_015.png": 4623,
	"./Plant_016.png": 132,
	"./Plant_017.png": 3165,
	"./Plant_018.png": 218,
	"./Plant_018_1.png": 8990,
	"./Plant_018_2.png": 9349,
	"./Plant_Catalyst_003.png": 4334,
	"./Plant_Catalyst_004.png": 6801,
	"./Skill_001.png": 660,
	"./Skill_002.png": 3119,
	"./Skill_003.png": 8022,
	"./Skill_004.png": 3001,
	"./Skill_005.png": 896,
	"./Skill_006.png": 2651,
	"./Skill_007.png": 8994,
	"./Skill_008.png": 9861,
	"./Skill_009.png": 2348,
	"./Skill_010.png": 9154,
	"./Skill_011.png": 3979,
	"./Skill_012.png": 5648,
	"./Skill_013.png": 121,
	"./Skill_014.png": 38,
	"./Skill_015.png": 6975,
	"./Skill_016.png": 116,
	"./Skill_017.png": 4013,
	"./Skill_018.png": 6234,
	"./Skill_019.png": 3987,
	"./Skill_020.png": 4659,
	"./Skill_021.png": 3082,
	"./Skill_022.png": 7745,
	"./Skill_023.png": 1448,
	"./Skill_024.png": 2967,
	"./Skill_025.png": 5278,
	"./Skill_026.png": 7381,
	"./Skill_027.png": 4492,
	"./Skill_028.png": 4379,
	"./Skill_029.png": 5378,
	"./Skill_030.png": 6936,
	"./Skill_031.png": 8065,
	"./Skill_032.png": 7482,
	"./Skill_033.png": 2691,
	"./Skill_035.png": 4357,
	"./Skill_036.png": 350,
	"./Skill_037.png": 9575,
	"./Skill_038.png": 9664,
	"./Skill_039.png": 5913,
	"./Skill_040.png": 3225,
	"./Skill_041.png": 8400,
	"./Skill_042.png": 6731,
	"./Skill_043.png": 2514,
	"./Skill_044.png": 5021,
	"./Skill_045.png": 5076,
	"./Skill_046.png": 9727,
	"./Skill_047.png": 3398,
	"./Skill_048.png": 5329,
	"./Skill_049.png": 7464,
	"./Skill_050.png": 4638,
	"./Skill_051.png": 7655,
	"./Skill_052.png": 3372,
	"./StoryArt_1_02.png": 892,
	"./StoryArt_1_03.png": 3781,
	"./StoryArt_1_04.png": 9482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;